import Loadable from 'react-loadable';

export const Animation = Loadable({
  loader: () => import(/* webpackChunkName: "lottie-web-player"*/ '../lottie').then(module => module.Lottie),
  loading: () => null
});
